import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';
import { SX } from './leaderboard/leaderboardData';

/** One figure in the strip above a SkillX table. */
export default function SkillxStatCard({ icon, value, label, color }) {
  return (
    <Box
      sx={{
        p: 2,
        height: '100%',
        borderRadius: `${SX.radius.md}px`,
        background: SX.card,
        border: `1px solid ${SX.borderStrong}`,
        boxShadow: SX.shadowSoft,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.25}>
        <Box
          sx={{
            width: 38,
            height: 38,
            flexShrink: 0,
            borderRadius: `${SX.radius.sm}px`,
            background: `${color}14`,
            color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Icon icon={icon} width={20} height={20} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 19, fontWeight: 800, lineHeight: 1.1, color: SX.text }}>
            {value}
          </Typography>
          <Typography noWrap sx={{ fontSize: 11.5, color: SX.textMuted }} title={label}>
            {label}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
